module.exports = __webpack_public_path__ + "static/lemonanimal1-dc768ea44cd54a6235e8f1ba04b24b5a.png";